import * as React from 'react';
const LanguagesCore = (props) => {
    const { Anchor, List, ListItem } = props.components;
    function renderLanguage(language, index) {
        return (React.createElement(ListItem, { key: index, className: "text-small" },
            React.createElement(Anchor, Object.assign({ isTextColor: true, isUnderlined: false }, language, { className: "text-weight-normal" }), language.label)));
    }
    return (React.createElement(List, { type: "unstyled", direction: "inline", bordered: true, className: props.className }, props.languages.map((language, key) => renderLanguage(language, key))));
};
export default LanguagesCore;
